<template>
    <div class="articleSettingBox">
        <el-collapse v-model="activeNames">
            <el-collapse-item title="内容" name="1">
                <ul class="settingUl">
                    <li>
                        <span>来源</span>
                        <el-select v-model="laiYvalue" @change="handleSelchansge" placeholder="请选择" size="small">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </li>
                    <li v-if="laiYvalue === '2'">
                        <!-- <el-autocomplete style="width: 100%;" class="inline-input" v-model="fenleiValue"
                            :fetch-suggestions="querySearch" placeholder="请输入内容" @select="handleSelect">
                        </el-autocomplete> -->
                        <el-select
                          v-model="fenleiValue"
                          multiple
                          collapse-tags
                          style="margin-left: 20px; width: 100%;"
                          @change="handleSelect"
                          placeholder="请选择">
                          <el-option
                            v-for="item in typeList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                          </el-option>
                        </el-select>
                    </li>
                    <li>
                        <span>属性</span>
                        <el-radio-group v-model="shuRadio" size="mini">
                            <el-radio-button label="全部"></el-radio-button>
                            <el-radio-button label="推荐"></el-radio-button>
                            <el-radio-button label="置顶"></el-radio-button>
                        </el-radio-group>
                    </li>
                    <li>
                        <span>数量</span>
                        <el-input-number size="mini" :min="1" v-model="num"></el-input-number>
                    </li>
                </ul>
            </el-collapse-item>
            <el-collapse-item title="内容样式" name="2">
                <el-radio-group v-model="data.neiRadio" class="nieradio" size="small">
                    <el-radio-button label="1"> <i class="font-icon font-icon-wz1"></i></el-radio-button>
                    <el-radio-button label="2"> <i class="font-icon font-icon-diyi"></i></el-radio-button>
                    <el-radio-button label="3"> <i class="font-icon font-icon-dier"></i></el-radio-button>
                    <el-radio-button label="4"> <i class="font-icon font-icon-wz2"></i></el-radio-button>
                    <el-radio-button label="5"> <i class="font-icon font-icon-wz2 tramicon"></i></el-radio-button>
                </el-radio-group>
                <ul class="settingUl">
                    <li>
                        <span>卡片样式</span>
                        <el-select v-model="data.conValue" placeholder="请选择" size="small">
                            <el-option v-for="item in options1" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </li>
                    <li v-if="data.neiRadio === '2' || data.neiRadio === '3'">
                        <span>图片比例</span>
                        <el-radio-group v-model="data.biliRadio" size="mini">
                            <el-radio-button label="1:1"></el-radio-button>
                            <el-radio-button v-if="data.neiRadio === '2'" label="2:1"></el-radio-button>
                            <el-radio-button v-if="data.neiRadio === '3'" label="4:3"></el-radio-button>
                            <el-radio-button v-if="data.neiRadio === '3'" label="3:2"></el-radio-button>
                        </el-radio-group>
                    </li>
                    <li>
                        <span>边角</span>
                        <el-radio-group v-model="data.bianjiaoRadio" size="mini">
                            <el-radio-button label="直角"></el-radio-button>
                            <el-radio-button label="圆角"></el-radio-button>
                        </el-radio-group>
                    </li>
                    <li>
                        <span>标题加粗</span>
                        <el-radio-group v-model="data.boldRadio" size="mini">
                            <el-radio-button label="无"></el-radio-button>
                            <el-radio-button label="有"></el-radio-button>
                        </el-radio-group>
                    </li>
                </ul>
            </el-collapse-item>
            <el-collapse-item title="组件样式" name="3">
              <comSetting :infoItme="data.infoItme"/>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>
<script>
import comSetting from '../comSetting'
import api from '../../api/index'
export default {
  name: 'wenzSetting',
  components: { comSetting },
  props: {
    data: Object
  },
  data () {
    return {
      activeNames: ['1'],
      laiYvalue: '1',
      shuRadio: '全部',

      fenleiValue: '',
      restaurants: [],
      num: 1,
      options: [
        {
          value: '1',
          label: '全部分类111'
        },
        {
          value: '2',
          label: '选择分类'
        }
      ],
      options1: [
        {
          value: '1',
          label: '无边白底'
        },
        {
          value: '2',
          label: '白底投影'
        },
        {
          value: '3',
          label: '描边白底'
        },
        {
          value: '4',
          label: '无边透明底'
        }
      ],
      typeList: []
    }
  },
  methods: {
    querySearch (queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    handleSelect (item) {
      console.log(item)
    },
    handleSelchansge (val) {
      if (val === '2') {
        console.log('选择的值', val)
        this.getType()
      }
    },
    async getType () {
      try {
        const data = { type: 'product' } // 需要发送的请求数据
        const response = await api.post('/applet/get_category', data)

        if (response.code === 0) {
          console.log('分类数据', response)
          this.typeList = response.data
        }
      } catch (error) {
        console.error('Error sending data:', error)
      }
    }
  }
}
</script>

<style scoped>
.articleSettingBox {
  padding: 0 20px;
}

.font-icon {
  font-size: 20px;
}
.tramicon {
  display: block;
  transform: scaleX(-1);
}
.nieradio {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
/deep/ .nieradio .el-radio-button__inner {
  padding: 9px 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/wenz/wenzSetting.vue